import { apiClient } from "../../utils/apiClient";
import { UserPermission } from "../../types/userPermission";

export const fetchUserPermissions = async (): Promise<UserPermission[]> => {
    const response = await apiClient.get('/usersPermissions');
    return response.data;
};

export const upsertUserPermission = async (userPermission: UserPermission): Promise<UserPermission> => {
    const response = await apiClient.post('/usersPermissions', userPermission);
    return response.data;
};

export const checkIfUserPermissionExists = async (user_id: number, permission_id: number): Promise<boolean> => {
    const response = await apiClient.get(`/usersPermissions/checkUserPermissionExists/${user_id}/${permission_id}`);
    return response.data.exists;
};


//api/usersPermissions
